import { Box, Flex, Text } from '@optiaxiom/react';
import { IconServer } from '@optimizely/axiom-icons';

export function RemoteMCPPlaceholder() {
  return (
    <Box mt="24">
      <Text fontWeight="500" fontSize="lg" mb="16">
        Remote MCP Servers
      </Text>
      <Box border="1" borderColor="border.secondary" rounded="md" bg="bg.secondary" p="24">
        <Flex flexDirection="column" alignItems="center" gap="12">
          <IconServer size={32} />
          <Text fontWeight="500">Remote MCP server management coming soon</Text>
          <Text color="fg.tertiary" fontSize="sm" style={{ textAlign: 'center' }}>
            This feature will allow you to connect to external MCP servers that provide additional
            tools and capabilities.
          </Text>
        </Flex>
      </Box>
    </Box>
  );
}
